import { render, staticRenderFns } from "./ReviewCollectingContacts.vue?vue&type=template&id=6c82fa5c&scoped=true&"
import script from "./ReviewCollectingContacts.vue?vue&type=script&lang=ts&"
export * from "./ReviewCollectingContacts.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewCollectingContacts.vue?vue&type=style&index=0&id=6c82fa5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82fa5c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConsentAdvertising: require('/usr/www/nuxt/components/ConsentAdvertising.vue').default})
